<app-header></app-header>
<app-sign-in
  [isLoading]="isLoading"
  (signInData)="onSubmit($event)"
  [whoSignIn]="UserTypeEnum.staff"
></app-sign-in>
